import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const config = require('@root/config/config');

export const fetchCompanies = createAsyncThunk(
    'company/fetchCompanies',
    async () => {
        const res = await fetch(config.adminApiHost + 'do/ListCompanies', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'AnyVal'
            },
            credentials: 'include',
            body: JSON.stringify({})
        });

        if (!res.ok) {
            throw new Error('Failed to fetch companies');
        }

        const data = await res.json();
        return data.map(c => ({ CompanyId: c.CompanyId, Name: c.Name }));
    },
    {
        condition: (_, { getState }) => {
            const { company } = getState();
            return company.companies.length === 0 && !company.loading;
        }
    }
);

export const companySlice = createSlice({
    name: 'company',
    initialState: {
        companies: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanies.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCompanies.fulfilled, (state, action) => {
                state.companies = action.payload;
                state.loading = false;
            })
            .addCase(fetchCompanies.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default companySlice.reducer;
